import { useCallback, useEffect, useState } from "react";
import { Table, Tag, Collapse } from "antd";
import moment from "moment";
import NetworkApi from "../../network/networkApi";

interface PlantDateChangeLogProps {
  plantId?: number;
  plantTypeId?: number;
}

const PlantDateChangeLog = ({
  plantId,
  plantTypeId,
}: PlantDateChangeLogProps) => {
  const [logs, setLogs] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const loadLogs = useCallback(async () => {
    if (!plantId && !plantTypeId) return;

    setLoading(true);
    try {
      const params: any = {};
      if (plantId) params.plantId = plantId;
      if (plantTypeId) params.plantTypeId = plantTypeId;

      const response = await NetworkApi.requestGet(
        "/api/plant/date-change-log",
        params
      );
      if (response.resultCode === 200) {
        setLogs(response.result || []);
      }
    } catch (error) {
      console.error("Failed to load logs:", error);
    } finally {
      setLoading(false);
    }
  }, [plantId, plantTypeId]);

  useEffect(() => {
    loadLogs();
  }, [loadLogs]);

  const getFieldLabel = (fieldName: string) => {
    const labels: any = {
      checkCultivationDate: "Тариалалтын хугацаа шалгах",
      cultivationStartMonth: "Тариалалтын эхлэх сар",
      cultivationEndMonth: "Тариалалтын дуусах сар",
      harvestStartMonth: "Ургац хураалтын эхлэх сар",
      harvestEndMonth: "Ургац хураалтын дуусах сар",
    };
    return labels[fieldName] || fieldName;
  };

  const formatValue = (fieldName: string, value: string) => {
    if (fieldName === "checkCultivationDate") {
      return value === "true" ? (
        <Tag color="green">Шалгана</Tag>
      ) : (
        <Tag color="orange">Шалгахгүй</Tag>
      );
    }
    return value;
  };

  const columns = [
    {
      title: "Огноо",
      dataIndex: "changedAt",
      key: "changedAt",
      width: 160,
      render: (date: string) => moment(date).format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      title: "Талбар",
      dataIndex: "fieldName",
      key: "fieldName",
      render: (fieldName: string) => getFieldLabel(fieldName),
    },
    {
      title: "Хуучин утга",
      dataIndex: "oldValue",
      key: "oldValue",
      render: (value: string, record: any) =>
        formatValue(record.fieldName, value),
    },
    {
      title: "Шинэ утга",
      dataIndex: "newValue",
      key: "newValue",
      render: (value: string, record: any) =>
        formatValue(record.fieldName, value),
    },
    {
      title: "Өөрчилсөн хэрэглэгч",
      dataIndex: "user",
      key: "user",
      render: (user: any) =>
        user ? `${user.lastName} ${user.firstName}` : "-",
    },
  ];

  if (!plantId && !plantTypeId) {
    return null;
  }

  return (
    <Collapse>
      <Collapse.Panel
        header={`Хугацааны өөрчлөлтийн түүх (${logs.length})`}
        key="1"
      >
        <Table
          columns={columns}
          dataSource={logs}
          loading={loading}
          rowKey="id"
          pagination={{ pageSize: 10 }}
          size="small"
        />
      </Collapse.Panel>
    </Collapse>
  );
};

export default PlantDateChangeLog;
